import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FeedbackBoard } from '@/components/feedback';
import { FeedbackItemWithDetails } from '@/types/feedback';

const Feedback: React.FC = () => {
  const navigate = useNavigate();

  const handleFeedbackClick = (feedback: FeedbackItemWithDetails) => {
    navigate(`/feedback/${feedback.slug}`);
  };

  return (
    <>
      <Helmet>
        <title>Community Feedback - Light Hunt</title>
        <meta 
          name="description" 
          content="Share your ideas and feedback to help shape the future of Light Hunt. Vote on features, report bugs, and discuss improvements with the community." 
        />
        <meta name="keywords" content="feedback, feature requests, bug reports, community, Light Hunt" />
        <link rel="canonical" href={`${window.location.origin}/feedback`} />
        
        {/* Open Graph */}
        <meta property="og:title" content="Community Feedback - Light Hunt" />
        <meta property="og:description" content="Share your ideas and feedback to help shape the future of Light Hunt." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${window.location.origin}/feedback`} />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Community Feedback - Light Hunt" />
        <meta name="twitter:description" content="Share your ideas and feedback to help shape the future of Light Hunt." />
      </Helmet>

      <div className="container mx-auto px-4 py-8">
        <FeedbackBoard onFeedbackClick={handleFeedbackClick} />
      </div>
    </>
  );
};

export default Feedback;